{
  "seo": {
    "title": "Accessibility Statement",
    "description": "Learn about CuriPop's accessibility commitment and support options."
  },
  "title": "Accessibility Statement",
  "updated": "Last updated: {date}",
  "sections": {
    "commitment": {
      "title": "Our Commitment",
      "body1": "CuriPop is committed to making our website and learning platform accessible and usable for everyone, including people with disabilities.",
      "body2": "We aim to align with the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA and continue improving accessibility across the product."
    },
    "features": {
      "title": "Accessibility Features",
      "items": [
        "Semantic page structure and heading hierarchy on core pages.",
        "Keyboard-accessible navigation and interactive controls.",
        "Focus visibility for interactive elements.",
        "Alternative text support for meaningful images.",
        "Color contrast considerations in primary UI components.",
        "Responsive layouts that support zoom and different screen sizes."
      ]
    },
    "improvements": {
      "title": "Ongoing Improvements",
      "body1": "Accessibility is an ongoing process. We regularly review and update components, content, and workflows to improve compatibility with assistive technologies and keyboard-only navigation.",
      "body2": "We also prioritize accessibility fixes when issues are identified by users, QA, or internal audits."
    },
    "thirdParty": {
      "title": "Third-Party Content",
      "body1": "Some parts of the experience may rely on third-party services or embedded content. We cannot fully control the accessibility of those services, but we evaluate them and provide alternatives where practical."
    },
    "support": {
      "title": "Feedback and Support",
      "body1": "If you experience an accessibility barrier, please contact us. Include the page URL, a description of the issue, and any assistive technology you are using so we can investigate quickly.",
      "contact": "Contact:"
    }
  }
}
